// extracted by mini-css-extract-plugin
export default {"formHeading":"KL-z","form":"LL-z","submitBtn":"ML-z","disabled":"NL-z","input":"OL-z","error":"PL-z","submitMsg":"QL-z","signIn":"RL-z"};